import { useMemo } from 'react'
import { useRouter } from '@shared/hooks/use-router'
import { useACL } from '@shared/hooks/use-acl.hook'
import { useAuditQuery } from '@modules/company-profile/use-audit-query.hook'
import { Roles } from '@shared/types'

export function useDisableDuringOngoingAudit(companyID: string) {
  const { query } = useRouter<{ auditID?: string }>()
  const { is } = useACL()

  const isPublishedAuditView = !query?.auditID

  const { companyProfile } = useAuditQuery(true, Number(companyID))
  const hasOngoingAudit = !!companyProfile?.ongoingAuditId

  const shouldDisable = useMemo(
    () =>
      isPublishedAuditView &&
      hasOngoingAudit &&
      is([Roles.ClientEditor, Roles.ClientAdministrator]),
    [isPublishedAuditView, hasOngoingAudit, is]
  )

  const tooltipText = 'Trwa audyt, edycja możliwa po jego zakończeniu'

  return { shouldDisable, tooltipText }
}


